import { render } from "./HeroiconsSolidAcademicCap.vue?vue&type=template&id=f9a7882a"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidAcademicCap.vue"]])

export default __exports__